import { React, useState, useEffect } from 'react';
import NavigationUser from '../../../common/navigationUser/NavigationUser';
import { CustomButton } from '../../../utils/Utils';
import style from './conferenceView.module.scss';
import cinema from './../../../../img/Conference.png';
import { Image } from 'antd';

const ConferenceView = () => {
  const { container, iframe } = style;
  const [conference, setConference] = useState({});

  useEffect(() => {
    setConference(JSON.parse(localStorage.getItem('conf')));
  }, []);

  const handleShowOnYoutube = () => {
    const id = conference.youtubeLink.split('embed/');
    const link = `https://www.youtube.com/watch?v=${id[1]}`;
    window.open(link,'_blank');
  };


  return (
    <>
      <NavigationUser brandSize="122px" conference={conference.name}/>
      <div className={container}>
        <Image preview={false} src={cinema} alt="" />
        <div className={iframe}>
          <div>
            <div>
              <iframe style={{transform: 'rotate3d(0, 4, -1, 2deg'}} width="560" height="315" src={conference.youtubeLink} title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
            </div>
          </div>
        </div>
        <div>
          <div>
            <div>
              <h2>
                {conference.name}
              </h2>
            </div>
            <div>{conference.description}</div>
          </div>
          <div>
            <CustomButton onclick={handleShowOnYoutube} style={{alignSelf: 'center', width: '100%'}}color="btnPrimary" size="bg" content="VER EN YOUTUBE"/>
            <div>
              <div>
                <div style={{backgroundImage: `url(${conference.image})`}}></div>
              </div>
              <div>
                <h3>{conference.speakers}</h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ConferenceView;
